export const USER_NOT_CONFIRMED_CODE = 4009;
export const VERIFICATION_EMAIL_SENT_CODE = 2003;
export const EMAIL_ALREADY_VERIFIED_CODE = 2005;
export const RESEND_VERIFICATION_COOLDOWN_MS = 30000;

export const VERIFICATION_REQUIRED_MESSAGE =
  'You have not verified your email yet. Please check your inbox for the activation link. If you don’t see it, check your spam folder and mark it as “Not Spam.” If the email is missing or expired, resend it now.';

export const VERIFICATION_EMAIL_SENT_MESSAGE =
  'Verification email sent. Please check your inbox and spam folder.';

export const RESEND_VERIFICATION_ERROR_MESSAGE =
  'Unable to resend verification email. Please try again later.';
